import React, { useState } from 'react';
import Logo from '../logos/white_logo.png';

const Navbar = () => {
    return <div className="navbar fixed top-0 bg-black shadow-sm w-full z-50">
        <img src={Logo} />
    </div>;
};

export default Navbar;